module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-list py-3"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.email.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[13][2]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input.email),
      expression: "input.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "email",
      "value": "",
      "placeholder": "abc@abc.com"
    },
    domProps: {
      "value": (_vm.input.email)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.email.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.email,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[13][1]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.email,
      "type": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[13][2]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.family_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[13][3]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input.family_name),
      expression: "input.family_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Yamada"
    },
    domProps: {
      "value": (_vm.input.family_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.family_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.family_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.family_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[13][3]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.given_name.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[13][4]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input.given_name),
      expression: "input.given_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "Tarou"
    },
    domProps: {
      "value": (_vm.input.given_name)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.given_name.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.given_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.given_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[13][4]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.password.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[13][5]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input.password),
      expression: "input.password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": "********"
    },
    domProps: {
      "value": (_vm.input.password)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.password.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.password,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[13][5]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.confirm_password.$error
    }
  }, [_c('label', {
    staticClass: "col-5 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[13][7]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input.confirm_password),
      expression: "input.confirm_password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "password",
      "value": "",
      "placeholder": "********"
    },
    domProps: {
      "value": (_vm.input.confirm_password)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.confirm_password.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.confirm_password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.given_name,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[13][8]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[13][8]"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('router-link', {
    staticClass: "btn w-100 btn-lg btn-default",
    attrs: {
      "tag": "button",
      "to": {
        name: 'top',
        params: {}
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[13][9]"
    }
  })], 1)], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-737524f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/PasswordRemindForm/PageForm.vue
// module id = 715
// module chunks = 0